import config from '@/config';
import fetchWrapper from '@/services/fetchWrapper.service';

function buildQuery(params = {}) {
  const query = new URLSearchParams();
  if (params.cursor) {
    query.set('cursor', params.cursor);
  } else if (params.after) {
    query.set('after', params.after);
  }
  if (params.before) {
    query.set('before', params.before);
  }
  if (typeof params.limit === 'number' && Number.isFinite(params.limit) && params.limit > 0) {
    query.set('limit', String(params.limit));
  }
  return query.toString();
}

function getByChannel(channelId, options = {}) {
  const query = buildQuery(options);
  const baseUrl = `${config.apis.api.url}/channelmessages/channel/${channelId}`;
  const url = query ? `${baseUrl}?${query}` : baseUrl;
  return fetchWrapper.get(url, { injectToken: true });
}

function create(channelId, payload = {}) {
  const normalizedPayload = typeof payload === 'string'
    ? { text: payload }
    : (payload && typeof payload === 'object' ? { ...payload } : {});

  const body = {};

  if (typeof normalizedPayload.text === 'string' && normalizedPayload.text.trim().length > 0) {
    body.text = normalizedPayload.text.trim();
  }

  if (normalizedPayload.stickerId) {
    body.stickerId = normalizedPayload.stickerId;
  }
  if (normalizedPayload.sticker) {
    body.sticker = normalizedPayload.sticker;
  }

  if (normalizedPayload.mediaList && Array.isArray(normalizedPayload.mediaList) && normalizedPayload.mediaList.length > 0) {
    body.mediaList = normalizedPayload.mediaList;
  } else if (normalizedPayload.media) {
    body.media = normalizedPayload.media;
  }

  if (normalizedPayload.metadata && typeof normalizedPayload.metadata === 'object') {
    body.metadata = normalizedPayload.metadata;
  }

  return fetchWrapper.post(`${config.apis.api.url}/channelmessages/channel/${channelId}`, {
    injectToken: true,
    body,
  });
}

function requestDirectUpload(channelId, payload = {}) {
  const body = {
    type: payload.type,
  };

  if (payload.mimeType) body.mimeType = payload.mimeType;
  if (payload.fileName) body.fileName = payload.fileName;
  if (typeof payload.fileSize === 'number') body.fileSize = payload.fileSize;
  if (payload.metadata && typeof payload.metadata === 'object') body.metadata = payload.metadata;

  return fetchWrapper.post(`${config.apis.api.url}/channelmessages/channel/${channelId}/media/direct-upload`, {
    injectToken: true,
    body,
  });
}

function remove(messageId) {
  return fetchWrapper.delete(`${config.apis.api.url}/channelmessages/${messageId}`, {
    injectToken: true,
  });
}

function markAsRead(channelId, messageIds) {
  const ids = Array.isArray(messageIds) ? messageIds : [];
  if (!channelId) {
    return Promise.resolve({ response: { ok: false }, data: null });
  }
  return fetchWrapper.post(`${config.apis.api.url}/channelmessages/channel/${channelId}/read`, {
    injectToken: true,
    body: { messageIds: ids },
  });
}

const ChannelMessagesService = {
  getByChannel,
  create,
  requestDirectUpload,
  remove,
  markAsRead,
};

export default ChannelMessagesService;